import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isLexMode } from '@/utils/lexDomain';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // lex.ivoliq: Nach Logout zurück zum lex-Login statt zum ivoliq-Login.
    if (isLexMode()) {
      return <Navigate to="/lex-login" state={{ loggedOut: true }} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;